<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0 pt-2">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.teacherAppointments') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="teacherAppointmentsTable.additionalFilters"
										:default-sort="teacherAppointmentsTable.defaultSort"
										:excel="false"
										:fields="teacherAppointmentsTable.headers"
										:header-selection-key="'teacher-appointments-headers'"
										:height="teacherAppointmentsTable.height"
										:total-records="teacherAppointmentsTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in teacherAppointmentsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('course')">
												{{ item.planned_course.course.code }}
											</td>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('date')">
												{{ item.date != null ? item.date.split('-').reverse().join('.') : '' }}
											</td>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('start_time')">
												{{ extractTimeFromDateTime(item.start_time) }}
											</td>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('end_time')">
												{{ extractTimeFromDateTime(item.end_time) }}
											</td>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('duration')">
												{{ appointmentDuration(item.start_time, item.end_time) }}
											</td>
											<td v-if="teacherAppointmentsTable.selectedHeaders.includes('office')">
												{{ item.planned_course.office.name }}
											</td>
											<td
												v-if="
													teacherAppointmentsTable.selectedHeaders.includes(
														'appointment_location'
													)
												"
											>
												{{
													item.appointment_location.classroom_id
														? item.appointment_location.classroom.name
														: item.appointment_location.ship.name
												}}
											</td>
											<td
												v-if="
													teacherAppointmentsTable.selectedHeaders.includes('course_module')
												"
											>
												{{ item.course_module.name }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'TeacherAppointments',
	components: { TheTable },
	props: {
		teacherId: [String, Number],
	},
	data: function () {
		return {
			teacherAppointmentsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.course'), value: 'course', type: '', sortable: false, allowFilter: true },
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: true },
					{
						text: this.$t('fields.startAppointmentTime'),
						value: 'start_time',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.endAppointmentTime'),
						value: 'end_time',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.duration'),
						value: 'duration',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office',
						sortable: false,
						type: '',
						allowFilter: false,
					},
					{
						text: this.$t('fields.appointmentLocation'),
						value: 'appointment_location',
						sortable: false,
						type: '',
						allowFilter: false,
					},
					{
						text: this.$t('fields.module'),
						value: 'course_module',
						sortable: false,
						type: '',
						allowFilter: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.teacherAppointmentsTable.selectedHeaders = headers;
		},
		extractTimeFromDateTime(dateTime) {
			const date = new Date(dateTime);

			if (isNaN(date)) {
				throw new Error('Invalid date-time string');
			}

			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');

			return `${hours}:${minutes}`;
		},
		appointmentDuration(startTime, endTime) {
			const startTimeDate = new Date(startTime);
			const endTimeDate = new Date(endTime);

			const timeDifferenceMillis = endTimeDate - startTimeDate;

			const hours = Math.floor(timeDifferenceMillis / 3600000);
			const minutes = Math.floor((timeDifferenceMillis % 3600000) / 60000);

			const formattedTimeSpan = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

			return formattedTimeSpan;
		},
		reloadData(request) {
			this.teacherAppointmentsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers-appointments/' + this.teacherId,
				request,
				(data, success) => {
					if (success) {
						vm.teacherAppointmentsTable.items = data.items;
						vm.teacherAppointmentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherAppointmentsTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
